module.exports = __webpack_public_path__ + "static/media/omisego.faaac927.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/omisego.svg
// module id = 1146
// module chunks = 0